let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6cp8c")).then(() => parcelRequire('3pHpm'));